import { ActionAutoValoration } from "@app/enums/auto-valoration.enums";
import { AssessmentPragmaPower, AssessmentPragmaPowerRequest } from "@app/interface/assesment-pragmapower";
import { PragmaPowerBehaviorDefinition, PragmaPowerBehaviorDefinitionsRequest } from "@app/interface/pragma-power-behavior.interface";
import { PragmaPowerCategoriesRequest, PragmaPowerCategory } from "@app/interface/pragma-power-categories.interface";
import { PragmaPowerDefinition, PragmaPowerDefinitionRequest } from "@app/interface/pragma-power-definition.interface";
import { PragmaPowerScores, PragmaPowerScoresRequest, Score } from "@app/interface/pragma-power-scores-interface";
import { ValorationResponse } from "@app/interface/valoration.response";
import { createAction, props } from "@ngrx/store";



export const loadStateByAutoValorationMap = createAction(
  ActionAutoValoration.LOAD_HOME_AUTO_VALORATION,
  props<{ autoValorationMapGeneral: boolean }>()
);

export const loadAutoValorationDefinitions = createAction(
  ActionAutoValoration.LOAD_AUTO_VALORATION,
  props<{idTeamPP: string}>()
)

export const loadAutoValorationDefinitionsSuccess = createAction(
  ActionAutoValoration.LOAD_AUTO_VALORATION_SUCCESSFULLY,
  props<{valoration: ValorationResponse}>()
)

export const loadPragmaPowerCategories = createAction(
  ActionAutoValoration.LOAD_PRAGMAPOWERS_CATEGORIES,
  props<{pragmaPowerRequest: PragmaPowerCategoriesRequest}>()
)

export const loadPragmaPowerCategoriesSuccess = createAction(
  ActionAutoValoration.LOAD_PRAGMAPOWERS_CATEGORIES_SUCCESSFULLY,
  props<{pragmaPowerCategories: PragmaPowerCategory[]}>()
)
export const updatePragmaPowerCategoryState = createAction(
  ActionAutoValoration.UPDATE_PRAGMAPOWER_CATEGORY_STATE,
  props<{idCategory: number, newState: string}>()
)

export const loadPragmaPowerDefinition = createAction(
  ActionAutoValoration.LOAD_PRAGMAPOWER_DEFINITIONS,
  props<{pragmaPowerDefinitionRequest: PragmaPowerDefinitionRequest}>()
)

export const loadPragmaPowerDefinitionSuccess = createAction(
  ActionAutoValoration.LOAD_PRAGMAPOWER_DEFINITIONS_SUCCESSFULLY,
  props<{pragmaPowerDefinition: PragmaPowerDefinition[]}>()
)

export const loadPragmaPowersBehaviorsDefinition = createAction(
  ActionAutoValoration.LOAD_PRAGMAPOWERS_BEHAVIORS_DEFINITIONS,
  props<{pragmaPowerBehaviorId: number, pragmaPowerBehaviorDefinitionRequest: PragmaPowerBehaviorDefinitionsRequest}>()
)

export const loadPragmaPowersBehaviorsDefinitionSuccess = createAction(
  ActionAutoValoration.LOAD_PRAGMAPOWERS_BEHAVIORS_DEFINITIONS_SUCCESSFULLY,
  props<{pragmaPowerBehaviorDefinition: PragmaPowerBehaviorDefinition[]}>()
)

export const loadPragmaPowerScores = createAction(
  ActionAutoValoration.LOAD_PRAGMAPOWER_SCORES,
  props<{pragmaPowerScoresRequest: PragmaPowerScoresRequest}>()
)

export const loadPragmaPowerScoresSuccess = createAction(
  ActionAutoValoration.LOAD_PRAGMAPOWER_SCORES_SUCCESSFULLY,
  props<{pragmaPowerScores: PragmaPowerScores[]}>()
)

export const savePragmaPowerScore = createAction(
  ActionAutoValoration.SAVE_PRAGMAPOWER_SCORE_SELECTED,
  props<{score: Score}>()
)

export const savePragmaPowerScores = createAction(
  ActionAutoValoration.SAVE_PRAGMAPOWER_SCORES,
  props<{scores: Score[]}>()
)

export const setPragmaPowerBehaviorsSelected = createAction(
  ActionAutoValoration.SET_PRAGMAPOWER_BEHAVIORS_SELECTED
)

export const loadSelfAssessmentPragmaPowerDefinitions = createAction(
  ActionAutoValoration.LOAD_SELF_ASSESSMENT_PRAGMAPOWER_DEFINITIONS,
  props<{idAssessment: number, assessmentPragmaPowerRequest: AssessmentPragmaPowerRequest}>()
)

export const loadSelfAssessmentPragmaPowerDefinitionsSuccess = createAction(
  ActionAutoValoration.LOAD_SELF_ASSESSMENT_PRAGMAPOWER_DEFINITIONS_SUCCESSFULLY,
  props<{assessmentPragmaPower: AssessmentPragmaPower[]}>()
)

export const loadAllPragmaPowerBehaviorsDefinitions = createAction(
  ActionAutoValoration.LOAD_ALL_PRAGMAPOWERS_BEHAVIORS_DEFINITIONS,
  props<{pragmaPowerBehaviorDefinition: PragmaPowerBehaviorDefinition[]}>()
)

export const allBehaviorsDefinitionsLoaded = createAction(
  ActionAutoValoration.FLAG_ALL_PRAGMAPOWERS_BEHAVIORS_DEFINITIONS,
  props<{isLoaded: boolean}>()
)

export const loadAllPragmaPowerDefinitions = createAction(
  ActionAutoValoration.LOAD_ALL_PRAGMAPOWER_DEFINITIONS_SUCCESSFULLY,
  props<{pragmaPowerDefinition: PragmaPowerDefinition[]}>()
)

export const allPragmaPowerDefinitionsLoaded = createAction(
  ActionAutoValoration.FLAG_ALL_PRAGMAPOWERS_BEHAVIORS_DEFINITIONS,
  props<{isLoaded: boolean}>()
)

export const clearPragmaPowerScores = createAction(
  ActionAutoValoration.CLEAR_PRAGMAPOWER_SCORES,
)

export const resetAutoValorationState = createAction(
  ActionAutoValoration.RESET_AUTO_VALORATION_STATE
)

